module.exports = __webpack_public_path__ + "img/precheck.27b799cb.svg";